import router from "@/router"
import store from "@/store"
import { getToken } from "@/utils/tokenManager"
import { isEmpty } from "lodash"

let favIcons = document.querySelectorAll("link[rel~='icon']")

router.beforeEach((to, from, next) => {
  if (["login", "board-share", "board-share-full"].includes(to.name)) {
    next()
    return
  }
  const share = to.name?.includes("board-share") ? to.params.boardId || to.query.boardId : null
  let token = getToken(share)
  if (to.matched.some(record => !record.meta.public)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!token) {
      location.href = `/login?redirect=${to.fullPath}`
    } else if (isEmpty(store.getters.userInfo)) {
      store.dispatch("user/setToken", { token, share }).then(() => {
        next()
      })
    } else next()
    let titleSuffix = to.matched[0].meta?.titleSuffix || ""
    let curUser = store.getters.userInfo
    document.title = (curUser.companyName || "轻单") + titleSuffix
    let curLogo = curUser.companyLogo
    favIcons?.forEach(dom => {
      dom.href =
        (curLogo ||
          "https://new-service.oss-cn-hangzhou.aliyuncs.com/company-logo/defaultLogo.png") +
        "?x-oss-process=image/resize,w_30"
    })
  } else {
    if (token && isEmpty(store.getters.userInfo)) {
      // 模板预览页既可以公开访问,也可以带着当前登录状态使用
      store.dispatch("user/setToken", { token, share }).then(() => {
        next()
      })
    } else next()
  }
})
